import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-barcode",
  "use": "icon-barcode-usage",
  "viewBox": "0 0 11 8",
  "content": "<symbol viewBox=\"0 0 11 8\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-barcode\">\n    <g id=\"icon-barcode_chevron-right\">        \n        <path d=\"M0 0H1V8H0V0Z\" />\n        <path d=\"M2 0H6V8H2V0Z\" />\n        <path d=\"M7 0H9V8H7V0Z\" />\n        <path d=\"M11 0H10V8H11V0Z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol